// extracted by css-extract-rspack-plugin
export default {"root":"oHA1QJ","left":"SYrbK6","left-side-item-wrapper":"l4oIUm","leftSideItemWrapper":"l4oIUm","right":"iYqRgj","right-side-item-wrapper":"obG7ut","rightSideItemWrapper":"obG7ut"};